import { p as prisma } from "../../../../../chunks/prisma.js";
import { addMonths } from "date-fns";
const PATCH = async ({ params, request, locals }) => {
  if (!locals.user) return new Response("Unauthorized", { status: 401 });
  const id = params.id;
  const body = await request.json();
  const prev = await prisma.task.findUnique({ where: { id } });
  if (!prev) return new Response("Not found", { status: 404 });
  console.log("Updating task:", id, "with data:", body);
  const updated = await prisma.task.update({ where: { id }, data: {
    title: body.title ?? void 0,
    description: body.description ?? void 0,
    categoryId: body.categoryId ?? void 0,
    dueDate: body.dueDate ? new Date(body.dueDate) : void 0,
    column: body.column ?? void 0,
    sort_order: body.sort_order ?? void 0,
    recurrence_day_of_month: body.recurrence_day_of_month ?? void 0
  } });
  if (prev.column !== "DONE" && updated.column === "DONE") {
    await prisma.task.update({ where: { id }, data: { completedAt: /* @__PURE__ */ new Date() } });
    if (updated.recurrence_day_of_month) {
      const target = updated.recurrence_day_of_month;
      const base = addMonths(/* @__PURE__ */ new Date(), 1);
      const year = base.getFullYear();
      const month = base.getMonth();
      const lastDay = new Date(year, month + 1, 0).getDate();
      const day = Math.min(target, lastDay);
      const nextDue = new Date(year, month, day, 9, 0, 0);
      await prisma.task.create({ data: {
        title: updated.title,
        description: updated.description,
        categoryId: updated.categoryId,
        dueDate: nextDue,
        column: "IDEAS",
        sort_order: 1e3,
        recurrence_day_of_month: updated.recurrence_day_of_month
      } });
    }
  }
  return new Response(JSON.stringify(updated));
};
const DELETE = async ({ params, locals }) => {
  if (!locals.user) return new Response("Unauthorized", { status: 401 });
  await prisma.task.delete({ where: { id: params.id } });
  return new Response(null, { status: 204 });
};
export {
  DELETE,
  PATCH
};
